import React, { useState } from "react"
import PropTypes from "prop-types"
import Link from "components/Link"
import VideoModal from "components/VideoModal"
import theme from "styles/theme"

import { ReactComponent as DocIcon } from "images/icons/document.svg"
import { ReactComponent as PlayIcon } from "images/icons/playVideo.svg"
import { ReactComponent as PlusIcon } from "images/navPlus.svg"
import { ReactComponent as DownloadIcon } from "images/icons/download.svg"
import { ReactComponent as SpreadsheetIcon } from "images/icons/spreadsheet.svg"

const ResourceCard = ({ type, title, url }) => {
  const LinkComponent = type === "videoModal" ? ModalLauncher : Link
  const ActionIcon = type.toLowerCase().includes("download")
    ? DownloadIcon
    : PlusIcon
  let FileIcon, fileTitle
  switch (type) {
    case "pdf":
    case "pdfDownload":
      FileIcon = DocIcon
      fileTitle = "PDF"
      break
    case "spreadsheetDownload":
      FileIcon = SpreadsheetIcon
      fileTitle = "Spreadsheet"
      break
    case "video":
    case "videoModal":
      FileIcon = PlayIcon
      fileTitle = "Video"
      break
    default:
  }
  return (
    <LinkComponent
      href={url}
      css={{
        backgroundColor: theme.white,
        borderBottom: `8px solid ${theme.midBlue}`,
        padding: 20,
        transitionProperty: "box-shadow, border-bottom-color",
        transitionDuration: "250ms",
        ":hover": {
          boxShadow: theme.cardShadow,
          borderBottom: `8px solid ${theme.deepBlue}`,
        },
      }}
    >
      <div
        css={{
          ...theme.t5md,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: theme.midBlue,
          paddingBottom: 20,
        }}
      >
        <div
          css={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <FileIcon
            css={{
              width: 20,
              height: 20,
              marginRight: 12,
              color: theme.midBlue,
              [theme.mobile]: {
                height: 18,
                width: 18,
              },
            }}
          />
          {fileTitle}
        </div>
        <ActionIcon css={{ color: theme.midBlue, height: 18, width: 18 }} />
      </div>

      <div
        css={{
          ...theme.cardTitles,
          color: theme.textGray,
        }}
      >
        {title}
      </div>
    </LinkComponent>
  )
}

ResourceCard.propTypes = {
  type: PropTypes.oneOf([
    "pdf",
    "pdfDownload",
    "spreadsheetDownload",
    "video",
    "videoModal",
  ]).isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

export default ResourceCard

const ModalLauncher = ({ href, className, children }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        css={{
          appearance: "none",
          border: 0,
          borderRadius: 0,
          textDecoration: "none",
          display: "block",
          cursor: "pointer",
          textAlign: "inherit",
        }}
        className={className}
        onClick={() => {
          setOpen(true)
        }}
      >
        {children}
      </button>

      <VideoModal
        open={open}
        url={href}
        onRequestClose={() => {
          setOpen(false)
        }}
      />
    </>
  )
}

ModalLauncher.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}
